'use strict';

angular.module('cgmemApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('authenticated.accounts', {
        url: '/accounts',
        templateUrl: 'app/adminListOfAccounts/adminListOfAccounts.html',
        controller: 'AccountsCtrl',
				sp: {
					authenticate: true
				}
      })
			.state('authenticated.addaccount', {
        url: '/addaccount',
        templateUrl: 'app/adminListOfAccounts/addAccount.html',
        controller: 'AddAccountCtrl',
				sp: {
					authenticate: true
				}
      });
  });